import PropTypes from 'prop-types';
import Badge from '../Badge/Badge';

const STATUS_CONFIG = {
  approved: {
    color: 'green',
    label: 'Approved',
  },
  needs_review: {
    color: 'yellow',
    label: 'Needs Review',
  },
  resolved: {
    color: 'blue',
    label: 'Resolved',
  },
  suppressed: {
    color: 'red',
    label: 'Suppressed',
  },
};

function EmailDeliverabilityStatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.approved;

  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-md border border-slate-200 bg-slate-50 px-3 py-2">
      <span className="font-medium text-slate-700 text-sm">
        Email Deliverability
      </span>
      <Badge name={config.label} color={config.color} size="small" />
    </div>
  );
}

EmailDeliverabilityStatusBadge.propTypes = {
  status: PropTypes.string,
};

export default EmailDeliverabilityStatusBadge;
